import { useState, useEffect } from "react";
import { WrappedTick } from "@/components/radarLabels";
import {
  ResponsiveContainer, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, Tooltip,
} from "recharts";

export default function ProfileRadar({ data, color = "#C87A5B", testid }) {
  // Fix 2.1.1: Retrasar render de RadarChart hasta que el contenedor esté
  // montado en el DOM. Evita que Recharts mida dimensiones 0×0 en el primer
  // mount de StrictMode y crashee con un ResizeObserver error.
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => { setIsMounted(true); }, []);

  return (
    <div className="w-full h-72" data-testid={testid}>
      {isMounted && (
        <ResponsiveContainer width="100%" height="100%">
          <RadarChart data={data} outerRadius="62%">
            <PolarGrid stroke="#E8E2D9" />
            <PolarAngleAxis
              dataKey="dim"
              tick={(p) => <WrappedTick {...p} fontSize={11} fill="#5C666B" maxChars={13} />}
            />
            <PolarRadiusAxis angle={90} domain={[0, 100]} tick={false} stroke="#E8E2D9" />
            <Tooltip
              contentStyle={{
                backgroundColor: "white",
                border: "1px solid #E8E2D9",
                borderRadius: 8,
                fontSize: 12,
              }}
            />
            <Radar
              name="Perfil"
              dataKey="value"
              stroke={color}
              fill={color}
              fillOpacity={0.35}
              strokeWidth={2}
            />
          </RadarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
